module.exports = "<bulk-invoice-item-types-upload-details-page></bulk-invoice-item-types-upload-details-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bulkInvoiceItemTypesUploadDetailsView.html
// module id = 2220
// module chunks = 0